import gql from 'graphql-tag';

const register = gql`
  mutation register(
    $email: String!
    $password: String!
    $firstName: String!
    $lastName: String!
    $preferredName: String
    $portalId: String!
    $birthdateMonth: SelectInput!
    $birthdateDay: SelectInput!
    $birthdateYear: SelectInput!
    $graduationYear: SelectInput!
    $major: SelectInput!
    $streetAddress1: String!
    $streetAddress2: String
    $city: String!
    $state: String!
    $postalCode: String
    $country: String!
  ) {
    register(
      email: $email
      password: $password
      firstName: $firstName
      lastName: $lastName
      preferredName: $preferredName
      portalId: $portalId
      birthdateMonth: $birthdateMonth
      birthdateDay: $birthdateDay
      birthdateYear: $birthdateYear
      graduationYear: $graduationYear
      major: $major
      streetAddress1: $streetAddress1
      streetAddress2: $streetAddress2
      city: $city
      state: $state
      postalCode: $postalCode
      country: $country
    ) {
      user {
        id
        email
      }
    }
  }
`;

export default register;
